import { render, staticRenderFns } from "./SliderList.vue?vue&type=template&id=49233b06&"
import script from "./SliderList.vue?vue&type=script&lang=js&"
export * from "./SliderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports